import React from 'react';
import * as api from '../../../services/api';
import ApprovePage from '../../presenters/ManagedRestroomServices/ApprovePage/ApprovePage';
import LoadingWidget from '../../widgets/LoadingWidget/LoadingWidget';
import { MANAGED_RESTROOM_SERVICES_URL } from '../../../route-names';
import { withRouter } from 'react-router-dom';
import * as MRSStatus from '../../../constants/MRSStatus';

class MRSApproveOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: null,
      mrsOrder: {},
      loading: true,
      mrsItems: [],
      orderUpdateInProgress: false
    };
  }

  componentDidMount() {
    this.getMRSOrder(this.props.match.params.orderId).then(() => {
      api.mrsItems.get().then((response) => {
        this.setState({ mrsItems: response.data });
      });
    });
  }

  getMRSOrder = (orderId) => {
    return api.mrsOrders.getById(orderId).then((response) => {
      const order = response.data;
      this.getCustomer(order.branchId, order.routeNumber, order.customerId);
      if (order.status != MRSStatus.APPROVAL_REQUIRED.name) {
        alert('This order does not require an approval.');
        this.backToDashboard();
      } else {
        this.setState({ mrsOrder: order });
      }
    });
  };

  getCustomer = (branchId, routeNumber, customerId) => {
    this.setState({ loading: true });

    api.customers.getOne(branchId, routeNumber, customerId).then((response) => {
      this.setState({ customer: response.data, loading: false });
    });
  };

  getAllSelectedItemsWithData = () => {
    return this.state.mrsOrder.lineItems.reduce((acc, lineItem) => {
      // Dispensers can be added multiple times for different fill items.
      // Combine them here.
      const existing = acc.find((e) => e.id == lineItem.itemId);

      if (existing) {
        existing.quantity += lineItem.quantity;
      } else {
        acc.push({
          ...lineItem,
          ...this.state.mrsItems.find((i) => i.id == lineItem.itemId)
        });
      }
      return acc;
    }, []);
  };

  backToDashboard = () => {
    this.props.history.push(MANAGED_RESTROOM_SERVICES_URL);
  };

  handleApprove = () => {
    this.setState({ loading: true });
    api.mrsOrders
      .submit(this.state.mrsOrder)
      .then((response) => {
        // MRS Order was successfully sent to ABS
        this.setState({ loading: false });
        this.backToDashboard();
      })
      .catch((reason) => {
        this.setState({ loading: false });
        // Failed to submit for some reason
        console.error(reason);
      });
  };

  handleDelete = () => {
    this.setState({ loading: true });
    api.mrsOrders
        .deleteRecord(this.state.mrsOrder)
        .then((response) => {
          // MRS Order was successfully deleted
          this.setState({ loading: false });
          this.backToDashboard();
        })
        .catch((reason) => {
          this.setState({ loading: false });
          // Failed to delete for some reason
          console.error(reason);
        });
  };

  render() {
    if (this.state.loading) {
      return <LoadingWidget />;
    } else {
      return (
        <ApprovePage
          items={this.getAllSelectedItemsWithData()}
          customer={this.state.customer}
          handleDelete={this.handleDelete}
          handleApprove={this.handleApprove}
        />
      );
    }
  }
}

export default withRouter(MRSApproveOrder);
